import { MutationObserverOptions, useMutation } from 'react-query';

import { RepayAirdropInput, IRepayAirdropOutput, queryClient, repayAirdrop } from 'clients/api';
import { useVaiControllerContract, useUmiTokenContract, useUmiVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

type Options = MutationObserverOptions<
    IRepayAirdropOutput,
  Error,
  Omit<RepayAirdropInput, 'umiControllerContract'>
>;

const useRepayAirdrop = (options?: Options) => {
  const umiControllerContract = useUmiVaultContract();

  return useMutation(
    FunctionKey.AIRDROP,
    (params: Omit<RepayAirdropInput, 'umiControllerContract'>) =>
        repayAirdrop({
          umiControllerContract,
        ...params,
      }),
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        // Invalidate queries related to fetching the user minted VAI amount
        queryClient.invalidateQueries(FunctionKey.GET_MINTED_USERINFO);
        queryClient.invalidateQueries(FunctionKey.GET_V_TOKEN_BALANCES_ALL);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );
};

export default useRepayAirdrop;
